import React, { useEffect, useState } from 'react';
import { Container, Spinner } from 'react-bootstrap';
import '../components-css/LatestYoutubeVideo.css';

const API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY;
const CHANNEL_ID = 'UCMQKDKy8mzksDB9q6BAs9QA'; // ID real del canal
const FALLBACK_VIDEO_ID = 'IyOPfdR8ijY';

const LatestYoutubeVideo = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showChannelCta, setShowChannelCta] = useState(false);

  useEffect(() => {
    const spotifyRegex = /https?:\/\/(?:open\.)?spotify\.com\/[\w/?=&%-.]+/i;
    const loadFallbackVideo = () => {
      if (!FALLBACK_VIDEO_ID) {
        setVideos([]);
        return Promise.resolve();
      }
      setShowChannelCta(true);
      setVideos([
        {
          id: FALLBACK_VIDEO_ID,
          title: 'Mensaje destacado',
          spotifyUrl: null
        }
      ]);
      return Promise.resolve();
    };

    if (!API_KEY) {
      loadFallbackVideo();
      setLoading(false);
      return;
    }

    fetch(
      `https://www.googleapis.com/youtube/v3/search?key=${API_KEY}&channelId=${CHANNEL_ID}&part=snippet,id&order=date&maxResults=5`
    )
      .then(res => res.json())
      .then(data => {
        if (data?.error) {
          const reason = data?.error?.errors?.[0]?.reason;
          if (reason === 'quotaExceeded') {
            return loadFallbackVideo();
          }
          return loadFallbackVideo();
        }

        const items = data.items || [];
        const videoIds = items
          .map(item => item?.id?.videoId)
          .filter(Boolean);

        if (videoIds.length === 0) {
          return loadFallbackVideo();
        }

        return fetch(
          `https://www.googleapis.com/youtube/v3/videos?key=${API_KEY}&id=${videoIds.join(',')}&part=snippet`
        )
          .then(res => res.json())
          .then(videoData => {
            if (!videoData?.items?.length) {
              return loadFallbackVideo();
            }

            const videoMap = new Map(
              (videoData.items || []).map(item => [item.id, item])
            );

            const orderedVideos = videoIds
              .map(id => videoMap.get(id))
              .filter(Boolean)
              .map(item => {
                const desc = item.snippet?.description || '';
                const match = desc.match(spotifyRegex);

                return {
                  id: item.id,
                  title: item.snippet?.title || 'Mensaje reciente',
                  spotifyUrl: match ? match[0] : null
                };
              });

            setVideos(orderedVideos);
          });
      })
        .catch(() => loadFallbackVideo())
      .finally(() => setLoading(false));
  }, []);

  return (
    <section id="mensajes" className="youtube-section">
      <Container>
        <div className="section-title text-center mb-4">
          <h2 className="section-title__title">Mensajes</h2>
        </div>
        {showChannelCta && (
          <div className="error-text">
            Mirá más mensajes en{' '}
            <a href="https://www.youtube.com/@iglesiacanaldevida" target="_blank" rel="noopener noreferrer">
              YouTube
            </a>.
          </div>
        )}
      </Container>
        {loading ? (
          <div className="text-center my-3"><Spinner animation="border" /></div>
        ) : videos.length === 0 ? (
          <div className="error-text">No se encontraron mensajes.</div>
        ) : (
          <div className="youtube-videos">
            <div className="youtube-featured">
              <div className="ratio ratio-16x9">
                <iframe
                  src={`https://www.youtube.com/embed/${videos[0].id}`}
                  title={videos[0].title}
                  allowFullScreen
                ></iframe>
              </div>
              {videos[0].spotifyUrl && (
                <div className="spotify-link">
                  <a href={videos[0].spotifyUrl} target="_blank" rel="noopener noreferrer">
                    <svg width="28" height="28" viewBox="0 0 168 168" xmlns="http://www.w3.org/2000/svg"><circle fill="#1DB954" cx="84" cy="84" r="84"/><path d="M120.1 115.2c-1.5 2.5-4.7 3.3-7.2 1.8-19.8-12.1-44.8-14.8-74.3-8.1-2.8.6-5.5-1.2-6.1-4-0.6-2.8 1.2-5.5 4-6.1 31.6-7 58.2-4 80.1 9.1 2.5 1.5 3.3 4.7 1.8 7.3zm10.3-21.6c-1.9 3-5.8 4-8.8 2.1-22.7-14-57.3-18.1-84.2-9.9-3.3 1-6.8-.8-7.8-4.1-1-3.3.8-6.8 4.1-7.8 30.2-9.1 67.1-4.7 92.2 11.1 3 1.9 4 5.8 2.1 8.6zm11.2-23.2c-27.1-16.1-71.8-17.6-97.5-9.6-3.8 1.2-7.8-.9-9-4.7-1.2-3.8.9-7.8 4.7-9 28.6-8.8 77.1-7.1 107.2 11.2 3.4 2 4.5 6.4 2.5 9.8-2 3.4-6.4 4.5-9.9 2.3z" fill="#fff"/></svg>
                    Escuchar en Spotify
                  </a>
                </div>
              )}
            </div>
            {videos.length > 1 && (
              <div className="youtube-list">
                <h3 className="youtube-list-title">Mensajes anteriores</h3>
                <div className="youtube-list-grid">
                  {videos.slice(1, 5).map(video => (
                    <div className="youtube-item" key={video.id}>
                      <a
                        className="youtube-thumb"
                        href={`https://www.youtube.com/watch?v=${video.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`Reproducir ${video.title}`}
                      >
                        <img
                          src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                          alt={video.title}
                          loading="lazy"
                        />
                        <span className="youtube-thumb__play" aria-hidden="true">
                          <svg viewBox="0 0 64 64" role="presentation">
                            <circle cx="32" cy="32" r="30" />
                            <polygon points="26,20 48,32 26,44" />
                          </svg>
                        </span>
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
    </section>
  );
};

export default LatestYoutubeVideo;
